import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isEmptyObject } from '../../../../../core/util/object';
import { hasSufficientDataToDisplayInsuranceProfile } from '../../../../../core/util/account';
import useSelectInsuranceProfile from '../../../hooks/useSelectInsuranceProfile';

export default (userProfileId: any) => {
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);
  const insuranceDetailsSubmitting = useSelector((state: any) => state.insuranceDetails.submitting);
  const npi = useSelector((state: any) => state.npi);

  return useMemo(() => {
    const isUpdatingInsuranceInformation = () => npi.submitting || insuranceDetailsSubmitting;

    const shouldShowCtaAddInsurance = () =>
      isEmptyObject(insuranceProfile) ||
      !hasSufficientDataToDisplayInsuranceProfile(insuranceProfile);

    return !isUpdatingInsuranceInformation() && shouldShowCtaAddInsurance();
  }, [insuranceProfile, insuranceDetailsSubmitting, npi]);
};
